import MapPin from './_MapPin';
import { mergeClasses } from '@griffel/react';

export default class FoodPin extends MapPin 
{
	constructor(id, latlng, type, options = {}) 
	{
		options.food_type = type;

		super(id, latlng, null, '', options);
	}

	initVars(options = {}) 
	{
		this._foodType = options.food_type;
		this._foodName = ['restaurant', 'cafe'][options.food_type - 1];

		this._markerClassName = mergeClasses('food', this._foodName);
	}

	makeHTML(options = {}) 
	{
		const img = `${process.env.PUBLIC_URL}/img/pin_${this._foodName}.png`;

		return `
		<div class="pin-scale">
			<div class="pin-inner">
				<div class="pin-image">
					<img src=${img} />
				</div>
			</div>
		</div>`;
	}
}
